import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useQueryParam } from '@chilecompra/react-kit/routes'
import { Button, Typography } from '@chilecompra/react-kit/components'
import { onUnsubscribeGenericThunk } from './Unsubscribe.actions'
import { DialogIcon, ErrorMessage, Strong } from './Unsubscribe.styles'

/**
 * The UnsubscribeSection' container.
 */
const UnsubscribeSection = () => {
  const dispatch = useDispatch()
  const [cancelUnsubscribe, setCancelUnsubscribe] = useState(false)
  const { error, loading, unsubscribe } = useSelector(state => state.unsubscribe)
  const qs = useQueryParam('qs')

  const handleUnsubscribe = () => dispatch(onUnsubscribeGenericThunk({ qs }))
  const handleDoNothing = () => setCancelUnsubscribe(true)

  return (
    <>
      {!unsubscribe && !cancelUnsubscribe && (
        <>
          <Typography margin="0 0 32px" variant="body2">
            Al cancelar tu suscripción, dejarás de recibir este tipo de mensajes en tu correo.
          </Typography>
          <Typography margin={error > 0 ? '0 0 50px' : '0 0 64px'} variant="body2">
            ¿Estás seguro(a) de que deseas cancelar la suscripción?
          </Typography>
          {!loading && error > 0 && (
            <ErrorMessage>
              {error < 4 && 'Lo sentimos, no se pudo guardar la información.'}
              {error >= 4 && (
                <>
                  Lo sentimos, al parecer nuestro sistema presenta problemas.
                  <br />
                  Por favor intente más tarde.
                </>
              )}
            </ErrorMessage>
          )}
          <Button color="primary" disabled={loading} margin="0 13px 0" variant="text" onClick={handleDoNothing}>
            No, mantener mi suscripción activa
          </Button>
          <Button color="default" loading={loading} margin="0 13px 0" onClick={handleUnsubscribe}>
            Si, deseo cancelar mi suscripción
          </Button>
        </>
      )}

      {unsubscribe && !loading && (
        <>
          <DialogIcon alt="Cancelación de Suscripción" src="/assets/images/circle_icon.svg" />
          <Typography margin="0 0 32px" variant="body2">
            <Strong>Tu suscripción a este tipo de mensajes ha sido cancelada exitosamente.</Strong>
            <br />
            Ya puedes cerrar esta ventana
          </Typography>
        </>
      )}

      {cancelUnsubscribe && (
        <>
          <DialogIcon alt="Cancelación de Suscripción" src="/assets/images/circle_icon.svg" />
          <Typography margin="0 0 32px" variant="body2">
            <Strong>Tu suscripción a este tipo de mensajes seguirá activa hasta que decidas cancelarla.</Strong>
            <br />
            Ya puedes cerrar esta ventana
          </Typography>
        </>
      )}
    </>
  )
}
export default UnsubscribeSection
